import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

import type { ShortcutHint } from '../../agent.types';

@Component({
  selector: 'agent-shortcut-hints',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './shortcut.hints.component.html',
  styleUrls: ['./shortcut.hints.component.less'],
})
export class AgentShortcutHintsComponent {

  public readonly $hints = input.required<ShortcutHint[]>({ alias: 'hints' });
}
